import {COMMON, CONSTANT} from "../common.js";

const TYPE_COMPANY = '2';

const MEMBER = (function () {
    let modules = {};

    modules.daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    modules.daysInMonthLeapYear = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    modules.today = new Date();
    modules.targetDate = new Date(1970, 0, 1);

    modules.callAjaxCheckValidationPerson = function () {
        let data = $('#form-member-person').serializeArray();

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_MEMBER_PERSON, 'POST', 'JSON', data)
            .then(res => {
                $.each(data, function (index, val) {
                    $(`.confirm-person #${val.name.replace(/_/g, "-")}`).empty().append(val.value);
                });
                $('.content.person-info').addClass('d-none');
                $('.content.confirm-person').removeClass('d-none');
            })
            .catch(err => {
                $('.person-info .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.name, '.err-name', '#name');
                    modules.showError(err.responseJSON.errors.katakana_name, '.err-katakana-name', '#katakana-name');
                    modules.showError(err.responseJSON.errors.phone_number, '.err-phone-number', '#phone, #country-code');
                    modules.showError(err.responseJSON.errors.birthdate, '.err-birthdate', '#select-year, #select-month, #select-day');
                    modules.showError(err.responseJSON.errors.zip_code, '.err-zip-code', '#zip-code');
                    modules.showError(err.responseJSON.errors.province, '.err-province', '#province');
                    modules.showError(err.responseJSON.errors.district, '.err-district', '#district');
                    modules.showError(err.responseJSON.errors.building, '.err-building', '#building');
                    modules.focusError(err.responseJSON.errors);
                }
            });
    }

    modules.callAjaxCheckValidationUpdatePerson = function () {
        let data = $('#form-member-person').serializeArray();

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_MEMBER_UPDATE_PERSON, 'POST', 'JSON', data)
            .then(res => {
                $.each(data, function (index, val) {
                    $(`.confirm-person #${val.name.replace(/_/g, "-")}`).empty().append(val.value);
                });
                let isMailLive = $('.confirm-person #is-mail-live');
                isMailLive.text() ? isMailLive.text('希望する') : isMailLive.text('希望しない');
                $('.content.person-info').addClass('d-none');
                $('.content.confirm-person').removeClass('d-none');
            })
            .catch(err => {
                $('.person-info .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.name, '.err-name', '#member-name');
                    modules.showError(err.responseJSON.errors.katakana_name, '.err-katakana-name', '#member-katakana-name');
                    modules.showError(err.responseJSON.errors.phone_number, '.err-phone-number', '#member-phone, #country-code');
                    modules.showError(err.responseJSON.errors.birthdate, '.err-birthdate', '#select-year, #select-month, #select-day');
                    modules.showError(err.responseJSON.errors.zip_code, '.err-zip-code', '#member-zip');
                    modules.showError(err.responseJSON.errors.province, '.err-province', '#member-province');
                    modules.showError(err.responseJSON.errors.district, '.err-district', '#member-district');
                    modules.showError(err.responseJSON.errors.building, '.err-building', '#member-address');
                    modules.focusError(err.responseJSON.errors);
                }
            });
    }

    modules.callAjaxCheckValidationCompany = function () {
        let data = $('#form-member-company').serializeArray();

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_MEMBER_COMPANY, 'POST', 'JSON', data)
            .then(res => {
                $.each(data, function (index, val) {
                    $(`.confirm-company #${val.name.replace(/_/g, "-")}`).empty().append(val.value);
                });
                $('.content.company-info').addClass('d-none');
                $('.content.confirm-company').removeClass('d-none');
            })
            .catch(err => {
                $('.company-info .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.company_name, '.err-company-name', '#company-name');
                    modules.showError(err.responseJSON.errors.person_rep, '.err-person-rep', '#person-representative');
                    modules.showError(err.responseJSON.errors.person_cha, '.err-person-cha', '#person-in-charge');
                    modules.showError(err.responseJSON.errors.person_cha_kana, '.err-person-cha-kana', '#person-in-charge-katakana');
                    modules.showError(err.responseJSON.errors.phone_number_company, '.err-phone-number-company', '#company-phone, #country-code');
                    modules.showError(err.responseJSON.errors.zip_code_company, '.err-zip-code-company', '#company-zip');
                    modules.showError(err.responseJSON.errors.province_company, '.err-province-company','#company-province');
                    modules.showError(err.responseJSON.errors.district_company, '.err-district-company', '#company-district');
                    modules.showError(err.responseJSON.errors.building_company, '.err-building-company', '#member-address');
                    modules.focusError(err.responseJSON.errors);
                }
            });
    }

    modules.callAjaxCheckValidationUpdateCompany = function () {
        let data = $('#form-member-company').serializeArray();

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_MEMBER_UPDATE_COMPANY, 'POST', 'JSON', data)
            .then(res => {
                if ($('#form-member-company #member-type').data('type') == TYPE_COMPANY) {
                    $('.confirm-company #company-name').empty().append($('#form-member-company #company-name').data('company-name'));
                    $('.confirm-company #person-rep').empty().append($('#form-member-company #person-representative').data('representative-name'));
                };
                $.each(data, function (index, val) {
                    $(`.confirm-company #${val.name.replace(/_/g, "-")}`).empty().append(val.value);
                });
                let isMailLive = $('.confirm-company #is-mail-live');
                isMailLive.text() ? isMailLive.text('希望する') : isMailLive.text('希望しない');
                $('.content.company-info').addClass('d-none');
                $('.content.confirm-company').removeClass('d-none');
            })
            .catch(err => {
                $('.company-info .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.company_name, '.err-company-name', '#company-name');
                    modules.showError(err.responseJSON.errors.person_rep, '.err-person-rep', '#person-representative');
                    modules.showError(err.responseJSON.errors.person_cha, '.err-person-cha', '#person-in-charge');
                    modules.showError(err.responseJSON.errors.person_cha_kana, '.err-person-cha-kana', '#person-in-charge-katakana');
                    modules.showError(err.responseJSON.errors.phone_number_company, '.err-phone-number-company', '#company-phone, #country-code');
                    modules.showError(err.responseJSON.errors.zip_code_company, '.err-zip-code-company', '#company-zip');
                    modules.showError(err.responseJSON.errors.province_company, '.err-province-company','#company-province');
                    modules.showError(err.responseJSON.errors.district_company, '.err-district-company', '#company-district');
                    modules.showError(err.responseJSON.errors.building_company, '.err-building-company', '#member-address');
                    modules.focusError(err.responseJSON.errors);
                }
            });
    }

    modules.callAjaxCheckValidationBidPerson = function () {
        let data = new FormData($('#form-bid-personal')[0])

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_BID_MEMBER_PERSONAL, 'POST', null, data)
            .then(res => {
                $('#form-bid-personal .error').empty();
                $('#form-bid-personal').submit();
            })
            .catch(err => {
                $('#form-bid-personal .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.img_front, '.err-img-front', '#img-front');
                    modules.showError(err.responseJSON.errors.img_back, '.err-img-back', '#img-back');
                    modules.focusError(err.responseJSON.errors);
                }
            })
    }

    modules.callAjaxCheckValidationBidCompany = function () {
        let data = new FormData($('#form-bid-company')[0])

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_BID_MEMBER_COMPANY, 'POST', null, data)
            .then(res => {
                $('#form-bid-company .error').empty();
                $('#form-bid-company').submit();
            })
            .catch(err => {
                $('#form-bid-company .error').empty();
                modules.formatIndex(err.responseJSON.errors)
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.company_number, '.err-company-number', '#company-number');
                    modules.showError(err.responseJSON.errors.files_front, '.err-files-front', '#files-front');
                    modules.showError(err.responseJSON.errors.files_back, '.err-files-back', '#files-back');
                    modules.showError(err.responseJSON.errors.files_pdf, '.err-files-pdf', '#preview-file-bid');
                    modules.focusError(err.responseJSON.errors);
                }
            })
    }

    modules.showError = function (err, element, hover) {
        if (err) {
            $(hover).addClass('hover-error')
            $(element).empty().append(err.shift());
        } else {
            $(hover).removeClass('hover-error')
            $(element).empty().append('')
        }
    }

    modules.focusError = function (err) {
        if (err) {
            let form = $('#form-bid-company .hover-error, #form-bid-personal .hover-error, #form-member-company .hover-error, #form-member-person .hover-error')
            let id = '#' + form.attr('id');
            $([document.documentElement, document.body]).animate({
                scrollTop: $(id).offset().top-100
            }, 500);
            $(id).trigger('focus');
        }
    }

    modules.formatIndex = function (errors) {
        for (let key in errors) {
            if (key.includes('.')) {
                let newKey = key.replace(/\./g, "_");
                errors[newKey] = errors[key];
                delete errors[key];
            }
        }
        return errors;
    }

    modules.setDate = function (date) {
        modules.setDays(date.getMonth());
        $("#select-day").val(date.getDate());
        $("#select-month").val(date.getMonth());
        $("#select-year").val(date.getFullYear());
    }

    modules.setDays = function (monthIndex) {
        let optionCount = $('#select-day option').length - 1;
        let daysCount = modules.daysInMonth[monthIndex];

        if (($('#select-year').val() % 4) == 0) {
            daysCount = modules.daysInMonthLeapYear[monthIndex];
        }

        if (optionCount < daysCount) {
            for (let i = optionCount; i < daysCount; i++) {
                $('#select-day')
                    .append($("<option></option>")
                        .attr("value", i + 1)
                        .text(`${i + 1}日`));
            }
        } else {
            for (let i = daysCount; i < optionCount; i++) {
                let optionItem = '#select-day option[value=' + (i + 1) + ']';
                $(optionItem).remove();
            }
        }
    }

    modules.setYears = function (val) {
        let year = modules.today.getFullYear();
        for (let i = 0; i < val; i++) {
            $('#select-year')
                .append($("<option></option>")
                    .attr("value", year - i)
                    .text(`${year - i}年`));
        }
    }

    modules.formatBirthdate = function () {
        let year = $('#form-member-person select[name="year"]').val(),
            month = parseInt($('#form-member-person select[name="month"]').val()) + 1,
            day = $('#form-member-person select[name="day"]').val();

        $('#form-member-person input[name="birthdate"]').val(`${year}/${month}/${day}`);
    }

    return modules;
})(window.jQuery, window, document);

$(document).ready(function () {
    MEMBER.setYears(100);
    if ($('.detail-member').length && typeof birthDay !== 'undefined') {
        if (birthDay) {
            MEMBER.setDate(new Date(birthDay));
        } else {
            $("#select-day").val('');
            $("#select-month").val('');
            $("#select-year").val('');
        }
    } else {
        MEMBER.setDate(MEMBER.targetDate);
    }

    $(document).on('change', '#select-month', function () {
        let monthIndex = $("#select-month").val();
        MEMBER.setDays(monthIndex);
    })

    $(document).on('change', '#select-year', function () {
        let monthIndex = $("#select-month").val();
        MEMBER.setDays(monthIndex);
    })

    $(document).on('click', '.type', function () {
        let type = $(this).val();
        if (type == 1) {
            window.location.href = CONSTANT.URL_CREATE_MEMBER_PERSON;
        }
        if (type == 2) {
            window.location.href = CONSTANT.URL_CREATE_MEMBER_COMPANY;
        }
    });

    $(document).on('click', '.verify-email .btn-resend', function () {
        let urlCurrent = new URL(window.location.href);
        urlCurrent.searchParams.set('sendMail', 1);
        window.location.href = urlCurrent.href;
    });

    $(document).on('input', '.just-number', function () {
        this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
    })

    $(document).on('click', '.btn-member.person', function (event) {
        event.preventDefault();
        MEMBER.formatBirthdate();
        memberPhone();
        MEMBER.callAjaxCheckValidationPerson();
    })

    $(document).on('click', '.btn-update-member-detail', function (event) {
        event.preventDefault();
        MEMBER.formatBirthdate();
        memberPhone();
        MEMBER.callAjaxCheckValidationUpdatePerson();
    })

    $(document).on('click', '.confirm-person .btn-back', function () {
        $('.content.person-info').removeClass('d-none');
        $('.content.confirm-person').addClass('d-none');
    })

    $(document).on('click', '.confirm-person .btn-next-step, .btn-confirm-update-member-detail', function () {
        $('#form-member-person').submit();
    })

    $(document).on('click', '.btn-member.company', function (event) {
        event.preventDefault();
        memberPhone();
        MEMBER.callAjaxCheckValidationCompany();
    })

    $(document).on('click', '.btn-update-company-detail', function (event) {
        event.preventDefault();
        memberPhone();
        MEMBER.callAjaxCheckValidationUpdateCompany();
    })

    $(document).on('click', '.confirm-company .btn-back', function () {
        $('.content.company-info').removeClass('d-none');
        $('.content.confirm-company').addClass('d-none');
    })

    $(document).on('click', '.confirm-company .btn-next-step, .btn-confirm-update-company-detail', function () {
        $('#form-member-company').submit();
    })

    $(document).on('click', '.btn-menu', function () {
        $('.sidebar').addClass('active');
        $('.btn-menu').css('visibility', 'hidden');
    });

    $(document).on('click', '.btn-close-sidebar', function () {
        $('.sidebar').removeClass('active');
        $('.btn-menu').css('visibility', 'visible');
    });

    $(document).on('click', '#btn-get-image-front', function () {
        $('#get-image-front').click();
    });

    $("#get-image-front").on("change", function () {
        const file = this.files[0];
        if (file) {
            $('#preview-img-front').attr('src', URL.createObjectURL(file));
        }
    });

    $(document).on('click', '#btn-get-image-back', function () {
        $('#get-image-back').click();
    });

    $("#get-image-back").on("change", function () {
        const file = this.files[0];
        if (file) {
            $('#preview-img-back').attr('src', URL.createObjectURL(file));
        }
    });

    $(document).on('click', '#btn-get-file-bid', function () {
        $('#get-file-bid').click();
    });

    $("#get-file-bid").on("change", function () {
        const file = this.files[0];
        if (file) {
            $('#preview-file-bid').attr('value',file.name);
        }
    });

    $(document).on('click', '.next-step-bid', function (event) {
        event.preventDefault();
        MEMBER.callAjaxCheckValidationBidPerson()
    })

    $(document).on('click', '.next-step-bid-company', function (event) {
        event.preventDefault();
        MEMBER.callAjaxCheckValidationBidCompany()
    })

    $(document).on('click', '.btn-reset-password', function (event) {
        event.preventDefault();
        let countryCode = $('.country-code').val();
        let phoneNumber = $('.phone-number').val();
        if ( !countryCode || !phoneNumber) {
            $('.phone').val('')
        } else {
            $('.phone').val('+' + countryCode + phoneNumber)
        }
        $('#form-member-reset-password').submit();
    })

    function memberPhone() {
        let countryCode = $('.country-code').val();
        let phone = $('.phone').val();
        if ( !countryCode || !phone) {
            $('.phone-number').val('')
        } else {
            $('.phone-number').val('+' + countryCode + phone)
        }
    }

    //show_bids_finish
    function nl2br (str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        let breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    $('.product-detail').on('click', function (e) {
        let product = $(this).data('product');
        let rank = $(this).data('product-rank');
        let modal = $('#modal-preview-product');
        modal.find('#product-name').text(product.name);
        modal.find('#product-rank-name').text(rank);
        modal.find('#product-cate-name').text($(this).data('product-cate'));
        modal.find('#product-id').text(product.id);
        modal.find('#product-name-detail').text(product.name);
        modal.find('#product-rank-detail').text(rank);
        modal.find('#product-note').html(nl2br(product.note));
        modal.find('#product-size').html(nl2br(product.size));
        modal.find('#product-color').html(nl2br(product.color));
        modal.find('#product-material').html(nl2br(product.material));
        modal.find('#product-accessories').html(nl2br(product.accessories));

        if  (product.description !== '') {
            modal.find('.description-box').show();
            modal.find('#product-description').html(nl2br(product.description));
        } else {
            modal.find('.description-box').hide();
        }

        let t = new Date(product.updated_at).toLocaleString("en-US", {timeZone: "Asia/Tokyo"});
        let d = new Date(t);
        let date;
        date = d.getFullYear() + "/" + ('0' + (d.getMonth() + 1)).slice(-2) + "/" + ('0' + d.getDate()).slice(-2) + " " +
            ('0' + d.getHours()).slice(-2) + ":" + ('0' + d.getMinutes()).slice(-2);
        modal.find('#product-bid-success-date').text(date);

        modal.find('#product-bid-amount').text(product.amount.toLocaleString('en'));

        //image
        let images = $(this).data('product-image');
        let defaultImg = $(this).data('image-default');
        $('#product-image-box').empty();
        images.forEach(function (image) {
            let element = '<div class="col-sm-3 mb-3">' +
                '<img class="file-upload-image-small" width="100%" height="100%" src="' + image + '" alt="your image"/>' +
                '</div>';

            $('#product-image-box').append(element);
        });

        let imgs = document.getElementsByClassName("file-upload-image-small");
        for (let i = 0; i < imgs.length; i++) {
            imgs[i].addEventListener("error", function(event) {
                event.target.src = defaultImg;
                event.onerror = null;
            });
        }
        modal.modal('show');
    });
});
